// @generated by protoc-gen-es v2.11.0 with parameter "target=ts"
// @generated from file mobility/v1/vehicle.proto (package mobility.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file mobility/v1/vehicle.proto.
 */
export const file_mobility_v1_vehicle: GenFile = /*@__PURE__*/
  fileDesc("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");

/**
 * ListVehicleModelsRequest - request for listing selectable vehicle models.
 *
 * @generated from message mobility.v1.ListVehicleModelsRequest
 */
export type ListVehicleModelsRequest = Message<"mobility.v1.ListVehicleModelsRequest"> & {
};

/**
 * Describes the message mobility.v1.ListVehicleModelsRequest.
 * Use `create(ListVehicleModelsRequestSchema)` to create a new message.
 */
export const ListVehicleModelsRequestSchema: GenMessage<ListVehicleModelsRequest> = /*@__PURE__*/
  messageDesc(file_mobility_v1_vehicle, 0);

/**
 * ListVehicleModelsResponse - response containing the list of selectable vehicle models.
 *
 * @generated from message mobility.v1.ListVehicleModelsResponse
 */
export type ListVehicleModelsResponse = Message<"mobility.v1.ListVehicleModelsResponse"> & {
  /**
   * @generated from field: repeated mobility.v1.VehicleModel vehicle_models = 1;
   */
  vehicleModels: VehicleModel[];
};

/**
 * Describes the message mobility.v1.ListVehicleModelsResponse.
 * Use `create(ListVehicleModelsResponseSchema)` to create a new message.
 */
export const ListVehicleModelsResponseSchema: GenMessage<ListVehicleModelsResponse> = /*@__PURE__*/
  messageDesc(file_mobility_v1_vehicle, 1);

/**
 * VehicleModel - a known vehicle model used to describe the immobilized vehicle in a Case
 * (e.g. "Toyota Yaris", "Peugeot 208").
 *
 * @generated from message mobility.v1.VehicleModel
 */
export type VehicleModel = Message<"mobility.v1.VehicleModel"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string label = 2;
   */
  label: string;
};

/**
 * Describes the message mobility.v1.VehicleModel.
 * Use `create(VehicleModelSchema)` to create a new message.
 */
export const VehicleModelSchema: GenMessage<VehicleModel> = /*@__PURE__*/
  messageDesc(file_mobility_v1_vehicle, 2);

/**
 * VehicleFeatures - additional features for vehicle solutions.
 *
 * @generated from message mobility.v1.VehicleFeatures
 */
export type VehicleFeatures = Message<"mobility.v1.VehicleFeatures"> & {
  /**
   * @generated from field: bool is_prm_accessible = 1;
   */
  isPrmAccessible: boolean;

  /**
   * @generated from field: bool has_air_conditioning = 2;
   */
  hasAirConditioning: boolean;

  /**
   * @generated from field: bool has_gps = 3;
   */
  hasGps: boolean;

  /**
   * @generated from field: bool has_child_seat = 4;
   */
  hasChildSeat: boolean;

  /**
   * @generated from field: bool has_winter_tires = 5;
   */
  hasWinterTires: boolean;

  /**
   * @generated from field: bool has_roof_rack = 6;
   */
  hasRoofRack: boolean;
};

/**
 * Describes the message mobility.v1.VehicleFeatures.
 * Use `create(VehicleFeaturesSchema)` to create a new message.
 */
export const VehicleFeaturesSchema: GenMessage<VehicleFeatures> = /*@__PURE__*/
  messageDesc(file_mobility_v1_vehicle, 3);

/**
 * VehicleProperties - properties of a vehicle solution
 *
 * @generated from message mobility.v1.VehicleProperties
 */
export type VehicleProperties = Message<"mobility.v1.VehicleProperties"> & {
  /**
   * @generated from field: mobility.v1.VehiclePowertrain power_train = 1;
   */
  powerTrain: VehiclePowertrain;

  /**
   * @generated from field: mobility.v1.VehicleTransmission transmission = 2;
   */
  transmission: VehicleTransmission;

  /**
   * @generated from field: mobility.v1.VehicleFeatures features = 3;
   */
  features?: VehicleFeatures;

  /**
   * @generated from field: mobility.v1.VehicleDoorRange door_range = 4;
   */
  doorRange: VehicleDoorRange;

  /**
   * @generated from field: int32 seats = 5;
   */
  seats: number;

  /**
   * @generated from field: int32 luggage_count = 6;
   */
  luggageCount: number;
};

/**
 * Describes the message mobility.v1.VehicleProperties.
 * Use `create(VehiclePropertiesSchema)` to create a new message.
 */
export const VehiclePropertiesSchema: GenMessage<VehicleProperties> = /*@__PURE__*/
  messageDesc(file_mobility_v1_vehicle, 4);

/**
 * VehicleCategory - ACRISS code identifying the vehicle type for rental vehicles.
 *
 * @generated from enum mobility.v1.VehicleCategory
 */
export enum VehicleCategory {
  /**
   * @generated from enum value: VEHICLE_CATEGORY_UNSPECIFIED = 0;
   */
  VEHICLE_CATEGORY_UNSPECIFIED = 0,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_0 = 1;
   */
  VEHICLE_CATEGORY_0 = 1,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_1 = 2;
   */
  VEHICLE_CATEGORY_1 = 2,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_2 = 3;
   */
  VEHICLE_CATEGORY_2 = 3,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_3 = 4;
   */
  VEHICLE_CATEGORY_3 = 4,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_4 = 5;
   */
  VEHICLE_CATEGORY_4 = 5,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_5 = 6;
   */
  VEHICLE_CATEGORY_5 = 6,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_6 = 7;
   */
  VEHICLE_CATEGORY_6 = 7,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_7 = 8;
   */
  VEHICLE_CATEGORY_7 = 8,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_8 = 9;
   */
  VEHICLE_CATEGORY_8 = 9,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_9 = 10;
   */
  VEHICLE_CATEGORY_9 = 10,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_A = 11;
   */
  VEHICLE_CATEGORY_A = 11,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_B = 12;
   */
  VEHICLE_CATEGORY_B = 12,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_C = 13;
   */
  VEHICLE_CATEGORY_C = 13,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_D = 14;
   */
  VEHICLE_CATEGORY_D = 14,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_E = 15;
   */
  VEHICLE_CATEGORY_E = 15,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_K = 16;
   */
  VEHICLE_CATEGORY_K = 16,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_M = 17;
   */
  VEHICLE_CATEGORY_M = 17,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_N = 18;
   */
  VEHICLE_CATEGORY_N = 18,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_P = 19;
   */
  VEHICLE_CATEGORY_P = 19,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_U = 20;
   */
  VEHICLE_CATEGORY_U = 20,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_V = 21;
   */
  VEHICLE_CATEGORY_V = 21,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_W = 22;
   */
  VEHICLE_CATEGORY_W = 22,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_X = 23;
   */
  VEHICLE_CATEGORY_X = 23,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_Y = 24;
   */
  VEHICLE_CATEGORY_Y = 24,

  /**
   * @generated from enum value: VEHICLE_CATEGORY_Z = 25;
   */
  VEHICLE_CATEGORY_Z = 25,
}

/**
 * Describes the enum mobility.v1.VehicleCategory.
 */
export const VehicleCategorySchema: GenEnum<VehicleCategory> = /*@__PURE__*/
  enumDesc(file_mobility_v1_vehicle, 0);

/**
 * VehiculeTransmission - transmission type for rental vehicle solutions.
 *
 * @generated from enum mobility.v1.VehicleTransmission
 */
export enum VehicleTransmission {
  /**
   * @generated from enum value: VEHICLE_TRANSMISSION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VEHICLE_TRANSMISSION_MANUAL = 1;
   */
  MANUAL = 1,

  /**
   * @generated from enum value: VEHICLE_TRANSMISSION_AUTOMATIC = 2;
   */
  AUTOMATIC = 2,
}

/**
 * Describes the enum mobility.v1.VehicleTransmission.
 */
export const VehicleTransmissionSchema: GenEnum<VehicleTransmission> = /*@__PURE__*/
  enumDesc(file_mobility_v1_vehicle, 1);

/**
 * VehiclePowertrain - powertrain type for vehicle solutions.
 *
 * @generated from enum mobility.v1.VehiclePowertrain
 */
export enum VehiclePowertrain {
  /**
   * @generated from enum value: VEHICLE_POWERTRAIN_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: VEHICLE_POWERTRAIN_COMBUSTION = 1;
   */
  COMBUSTION = 1,

  /**
   * @generated from enum value: VEHICLE_POWERTRAIN_HYBRID = 2;
   */
  HYBRID = 2,

  /**
   * @generated from enum value: VEHICLE_POWERTRAIN_PLUG_IN_HYBRID = 3;
   */
  PLUG_IN_HYBRID = 3,

  /**
   * @generated from enum value: VEHICLE_POWERTRAIN_ELECTRIC = 4;
   */
  ELECTRIC = 4,
}

/**
 * Describes the enum mobility.v1.VehiclePowertrain.
 */
export const VehiclePowertrainSchema: GenEnum<VehiclePowertrain> = /*@__PURE__*/
  enumDesc(file_mobility_v1_vehicle, 2);

/**
 * VehicleDoorRange - door-count range, from the ACRISS code's "Type" letter
 * (a coarse bucket, not an exact door count).
 *
 * @generated from enum mobility.v1.VehicleDoorRange
 */
export enum VehicleDoorRange {
  /**
   * @generated from enum value: VEHICLE_DOOR_RANGE_UNSPECIFIED = 0;
   */
  VEHICLE_DOOR_RANGE_UNSPECIFIED = 0,

  /**
   * @generated from enum value: VEHICLE_DOOR_RANGE_2_TO_3 = 1;
   */
  VEHICLE_DOOR_RANGE_2_TO_3 = 1,

  /**
   * @generated from enum value: VEHICLE_DOOR_RANGE_2_TO_4 = 2;
   */
  VEHICLE_DOOR_RANGE_2_TO_4 = 2,

  /**
   * @generated from enum value: VEHICLE_DOOR_RANGE_4_TO_5 = 3;
   */
  VEHICLE_DOOR_RANGE_4_TO_5 = 3,
}

/**
 * Describes the enum mobility.v1.VehicleDoorRange.
 */
export const VehicleDoorRangeSchema: GenEnum<VehicleDoorRange> = /*@__PURE__*/
  enumDesc(file_mobility_v1_vehicle, 3);

/**
 * VehicleModelService - provides reference data for vehicle models used to populate
 * the vehicle field (e.g. in the Case creation form).
 *
 * @generated from service mobility.v1.VehicleModelService
 */
export const VehicleModelService: GenService<{
  /**
   * ListVehicleModels returns the vehicle models available for selection.
   *
   * @generated from rpc mobility.v1.VehicleModelService.ListVehicleModels
   */
  listVehicleModels: {
    methodKind: "unary";
    input: typeof ListVehicleModelsRequestSchema;
    output: typeof ListVehicleModelsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_mobility_v1_vehicle, 0);

